<template>
    <div class="content-center" style="display: flex; flex-direction: column;">
        <div class="container-sm">
            <div class="title-center">
                <div class="uppercase">
                    {{ $t('auth.signIn') }}
                </div>
                <div class="subtitle-center">
                    {{ $t('auth.smsWithCodeHasBeenSent') }}
                </div>
            </div>

            <PinForm
                @submit="submit"
                @pin="
                    e => {
                        pin = e;
                    }
                "
                :android="isAndroid"
                class="mb20"
            />

            <div>
                <md-button
                    class="mt16 uppercase"
                    :class="{
                        'btn-default-blue': true,
                        'btn-default-action': false
                    }"
                    style="margin-left:0;"
                    @click="submit(pin)"
                    >{{ $t('auth.signIn') }}</md-button
                >
            </div>
            <div class="subtitle-center font-14">
                {{ $t('auth.verifiedPhoneIsMoreReliable') }}
            </div>
        </div>

        <div class="loading-overlay" v-if="loading">
            <div class="wrapper">
                <md-progress-spinner md-mode="indeterminate" :md-stroke="2" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PinForm from '../../components/Pin';

export default {
    components: {
        PinForm
    },

    data() {
        return {
            loading: false,
            pin: ''
        };
    },

    computed: {
        ...mapGetters({
            phone: 'auth/verifyPhoneNumber'
        }),

        isAndroid() {
            console.log(navigator.userAgent);
            if (/Android/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        }
    },

    methods: {
        ...mapActions({
            checkPin: 'auth/checkPin',
            sendPassenger: 'flotea/sendPassenger'
        }),

        async submit(pin) {
            const params = { phone: this.phone, pin };

            const redirect = localStorage.redirectFrom;
            const passenger = localStorage.passenger;
            let redirectRoute;

            if (redirect === undefined) {
                redirectRoute =
                    this.$route.query.redirectFrom &&
                    this.$route.query.redirectFrom !== '/logout'
                        ? this.$route.query.redirectFrom
                        : '/';
            } else if (redirect) {
                const parsed = JSON.parse(redirect);

                redirectRoute =
                    `/${parsed.redirectFrom}?` +
                    new URLSearchParams(parsed).toString();
            }

            const response = await this.checkPin(params);

            if (response && passenger) {
                const request = await this.sendPassenger(JSON.parse(passenger));

                if(request.valid || request.request_uuid){
                    localStorage.lastRequest = request.request_uuid;
                    localStorage.removeItem('spectrum');
                    this.$router.push(`/app/${request.request_uuid}`);
                }else{
                    this.$router.push({name:'passenger-spectrum'});
                }

                return;
            }

            if (response) {
                this.$router.push(redirectRoute);
                this.$toast.success(`${this.$t('global.welcomeBack')}!`);
                localStorage.removeItem('redirectFrom');
            } else {
                this.$toast.error(this.$t('global.incorrectLoginCredentials'));
            }
        }
    },

    mounted() {}
};
</script>

<style scoped>
.subtitle-center {
    font-size: 18px;
    margin-bottom: 16px;
    text-align: center;
}

.font-14 {
    font-size: 14px;
    margin-top: 16px;
}

input {
    padding: 10px;
    border: 1px solid #ddd;
    width: 50px;
    height: 50px;
    text-align: center;
    font-size: 30px;
}

@media (max-width: 375px) {
    input {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }
}
</style>
